<!--站点一览列表-->
<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">设备站点</span>
      </div>
    </div>
     <div class="tips" style="margin-bottom: 20px">
      <Icon
        type="md-alert"
        size="20"
        color="#2d8cf0"
        style="margin-right: 10px"
      />
      <div>设备站点代表设备所在地方的简称，如：重庆大学图书馆、西南医院第3住院部
      </div>
    </div>
    <div class="content-header">
      <div class="left">
        <Input v-model="page.value" placeholder="根据条件搜索" @on-enter="getData(1)">
          <Select v-model="page.cond" slot="prepend" style="width: 100px">
            <Option value="site.id">站点编号</Option>
            <Option value="site.name">站点名称</Option>
            <!-- <Option value="user_agent.id">所属编号</Option> -->
            <Option value="user_agent.name" v-if="!user.tp">所属</Option>
          </Select>
          <Button slot="append" icon="ios-search" @click="getData(1)"></Button>
        </Input>
        <Button style="margin: 2px 0 0 5px" @click="reset">重置</Button>
      </div>
      <div class="right">
        <!-- <Select v-model="page.is_del" style="margin-right: 5px">
          <Option :value="0">站点列表</Option>
          <Option :value="1">回收站</Option>
        </Select> -->
        <Poptip title="导出Excel" placement="left" trigger="hover">
          <Button style="margin: 0 5px 1px 0">导出Excel</Button>
          <div slot="content">
            <Button type="primary" style="margin-right: 5px" @click="exportData(0)">导出当前页</Button>
            <Button type="success" @click="exportData(1)">导出所有页</Button>
          </div>
        </Poptip>
        <Button type="primary" @click="preCreate">新增站点</Button>
      </div>
    </div>
    <Table :columns="columns" :data="data" :loading="tableLoading" @on-sort-change="tableSort"/>
    <div class="t-right">
      <Page @on-change="pageChange" @on-page-size-change="sizeChange" :total="total" :current="page.p + 1" show-elevator show-sizer show-total/>
    </div>

    <Modal v-model="visible" :width="640" class-name="site-edit-modal" :title="current.id?'修改站点':'新增站点'">
      <div class="site-modal">
        <div class="site-modal-alert">
          <Icon type="md-alert" size="18"/>
          <span>站点名称修改后，以前产生的订单记录中的站点名称也会同时被修改，请谨慎操作</span>
        </div>
        <Form :label-width="96" class="site-edit-form">
          <div class="site-form-card">
            <div class="site-form-card__title">
              <span>基础信息</span>
            </div>
            <FormItem label="站点名称:">
              <Input v-model="current.name" placeholder="输入站点名称"/>
            </FormItem>
            <FormItem label="站点所属:" v-if="siteAccess()">
              <Select v-model="current.agent_id" @on-change="onAgentChange" placeholder="默认自营">
                <Option :value="0">自营</Option>
                <Option v-for="(item,index) in agent" :value="item.id" :key="index">{{item.agent_name}}</Option>
              </Select>
            </FormItem>
          </div>

          <div class="site-form-card site-form-card--campus" v-if="showTmallArea()">
            <div class="site-form-card__title">
              <span>天猫服务区</span>
              <Tag :color="selectedTmallArea ? 'success' : 'default'">{{ selectedTmallArea ? '已关联' : '待选择' }}</Tag>
            </div>
            <FormItem label="服务区:">
              <Input
                v-model="tmallAreaSearchKeyword"
                placeholder="输入服务区名称">
                <Button slot="append" icon="ios-search" :loading="tmallAreaLoading" @click="searchTmallAreas">搜索</Button>
              </Input>
              <Select
                v-model="current.tmall_area_id"
                v-if="tmallAreas.length > 0"
                class="site-area-select"
                placeholder="选择服务区"
                @on-change="onTmallAreaChange">
                <Option v-for="item in tmallAreas" :value="item.id" :key="item.id">{{item.campus_area_name}}</Option>
              </Select>
            </FormItem>
            <div class="site-form-grid" v-if="selectedTmallArea">
              <FormItem label="学校名称:">
                <Input v-model="current.tmall_school_name" placeholder="输入学校名称"/>
              </FormItem>
              <FormItem label="校区名称:">
                <Input v-model="current.tmall_campus_name" placeholder="默认使用站点名称"/>
              </FormItem>
            </div>
            <FormItem label="校区logo:" v-if="selectedTmallArea">
              <Upload
                type="drag"
                :action="baseUrl + '/site/admin/upload'"
                :multiple="false"
                :max-size="1024"
                :show-upload-list="false"
                :before-upload="previewTmallLogo"
                :on-success="uploadTmallLogoSuccess"
                :on-error="uploadTmallLogoError"
                :on-exceeded-size="uploadTmallLogoSize"
                :format="['jpg','png','jpeg']">
                <div class="site-logo-uploader">
                  <div class="site-logo-preview" v-if="tmallLogoPreview || current.tmall_logo">
                    <img :src="tmallLogoPreview || getImageUrl(current.tmall_logo)"/>
                  </div>
                  <template v-else>
                    <Icon type="ios-cloud-upload" size="34"></Icon>
                    <p>点击或拖拽上传</p>
                  </template>
                </div>
              </Upload>
              <div class="site-upload-tip">支持 jpg、png、jpeg，大小不超过 1M</div>
            </FormItem>
          </div>
        </Form>
      </div>
      <div slot="footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="save" v-preventReClick :loading="loading">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { hasOneOf } from '@/libs/tools'
import excel from '@/libs/excel'
import config from '@/config'
export default {
  data () {
    return {
      page: {
        p: 0,
        l: 10,
        cond: 'site.id',
        value: '',
        is_del: 0,
        key: 'id',
        order: 'desc'
      },
      data: [],
      total: 0,
      tableLoading: false,
      hasExistingCampus: false,
      columns: [
        { title: '编号', key: 'id', sortable: 'custom', _sortKey: 'site.id', width: 100 },
        { title: '站点名称', key: 'name', sortable: 'custom', _sortKey: 'site.name' },
        { title: '所属', key: 'agent_name', sortable: 'custom', _sortKey: 'user_agent.name' },
        { title: '操作',
          width: 200,
          key: 'operator',
          render: (h, data) => {
            return h('div', {}, [
              h('Button', {
                props: { size: 'small', type: data.row.is_del ? 'success' : 'error' },
                style: { marginRight: '5px' },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: `是否${data.row.is_del ? '恢复' : '删除'}`,
                      content: `是否${data.row.is_del ? '恢复' : '删除'}该站点`,
                      loading: this.confirmLoading,
                      onOk: () => {
                        this.confirmLoading = true
                        this.DelSite({ id: data.row.id, is_del: data.row.is_del ? 0 : 1 }).then(res => {
                          if (res.status) {
                            this.$Message.success('操作成功')
                            this.getData()
                          } else {
                            this.$Message.error('无法删除已使用站点')
                          }
                          this.confirmLoading = false
                          // this.$Modal.remove()
                        })
                      }
                    })
                  }
                }
              }, data.row.is_del ? '恢复' : '删除'),
              h('Button', {
                props: { size: 'small', type: 'warning' },
                on: {
                  click: () => {
                    let temp = JSON.parse(JSON.stringify(data.row))
                    this.preCreate(temp)
                  }
                }
              }, '修改')
            ])
          } }
      ],
      visible: false,
      current: {},
      agent: [], // 代理商
      loading: false,
      confirmLoading: false,
      baseUrl: '',
      tmallAreas: [], // 天猫服务区列表
      tmallAreaLoading: false,
      tmallAreaSearchKeyword: '', // 天猫服务区搜索关键词
      tmallLogoPreview: '', // 校区logo本地预览
      selectedTmallArea: null // 选中的天猫服务区完整信息
    }
  },
  methods: {
    exportData (isAll) {
      let params = {
        title: ['编号', '站点名称', '所属'],
        key: ['id', 'name', 'agent_name'],
        autoWidth: true,
        filename: '站点列表'
      }
      if (isAll) {
        let page = JSON.parse(JSON.stringify(this.page))
        page.l = this.total
        page.p = 0
        this.getSite(page).then(res => {
          params.data = res.data
          excel.export_array_to_excel(params)
        })
      } else {
        params.data = this.data
        excel.export_array_to_excel(params)
      }
    },
    tableSort (col) {
      this.page.key = col.column._sortKey
      this.page.order = col.order
      this.getData()
    },
    reset () {
      this.page.cond = 'site.id'
      this.page.value = ''
      this.getData()
    },
    // 保存站点(新增 修改)
    save () {
      if (!this.current.name) {
        this.$Message.error('未填写站点名称')
        return
      }
      if (this.isCurrentTmallProvider() && !this.selectedTmallArea) {
        this.$Message.error('请选择天猫服务区')
        return
      }
      if (this.selectedTmallArea) {
        if (!this.current.tmall_school_name) {
          this.$Message.error('未填写学校名称')
          return
        }
        if (!this.current.tmall_campus_name) {
          this.$Message.error('未填写校区名称')
          return
        }
        if (!this.current.tmall_logo) {
          this.$Message.error('未上传校区logo')
          return
        }
      }
      this.loading = true
      if (!this.current.agent_id) {
        delete this.current.agent_id
      }
      let data = JSON.parse(JSON.stringify(this.current))
      delete data.agent_name
      delete data.campus
      delete data._index
      delete data._rowKey
      delete data.isTrusted

      // 如果选择了天猫服务区，添加天猫相关字段
      if (this.selectedTmallArea) {
        data.tmall_area_id = String(this.selectedTmallArea.area_id || this.selectedTmallArea.id)
        data.tmall_area_name = this.selectedTmallArea.area_name || this.selectedTmallArea.campus_area_name || ''
        data.tmall_school_name = this.current.tmall_school_name || ''
        data.tmall_campus_name = this.current.tmall_campus_name || this.current.name
        data.tmall_logo = this.current.tmall_logo || ''
        data.tmall_opening = 1
      } else {
        delete data.tmall_area_id
        delete data.tmall_area_name
        delete data.tmall_school_name
        delete data.tmall_campus_name
        delete data.tmall_logo
        delete data.tmall_opening
      }

      console.log('保存站点')
      this.saveSite(data).then(res => {
        this.loading = false
        if (res && (res.status || res.id)) {
          this.getData()
          this.visible = false
        } else {
          this.$Message.error((res && res.msg) || '站点名称重复,操作失败')
        }
      }).catch(() => {
        this.loading = false
        this.$Message.error('保存失败，请稍后重试')
      })
    },
    // 新增站点前 数据准备
    preCreate (data) {
      this.current = data || {}
      this.selectedTmallArea = null
      this.tmallAreas = []
      this.tmallAreaSearchKeyword = ''
      this.tmallLogoPreview = ''
      this.hasExistingCampus = false
      this.$set(this.current, 'tmall_opening', 1)
      if (this.current.campus) {
        this.hasExistingCampus = true
        this.hydrateCampusForm(this.current.campus)
      }
      if (!this.user.tp && !this.agent.length) {
        this.visible = true
        this.getAgentList({ is_del: 0, l: 1000 }).then(res => {
          this.agent = res.data
        })
      } else {
        this.visible = true
      }
    },
    // 站点选择代理商权限控制
    siteAccess () {
      return hasOneOf(['0'], this.access)
    },
    // 判断是否显示天猫服务区字段
    showTmallArea () {
      if (this.hasExistingCampus || this.selectedTmallArea) {
        return true
      }
      return this.isCurrentTmallProvider()
    },
    // 判断当前合作伙伴是否为天猫校园服务商
    isCurrentTmallProvider () {
      // 情况1：超级管理员 - 根据选择的合作伙伴判断
      if (!this.user.tp) {
        if (!this.current.agent_id) {
          return false
        }
        // agent_id为0表示自营，不需要天猫服务区
        if (Number(this.current.agent_id) === 0) {
          return false
        }
        const selectedAgent = this.agent.find(a => Number(a.id) === Number(this.current.agent_id))
        return selectedAgent && Number(selectedAgent.is_tmall) === 1
      }
      // 情况2：合作伙伴账户 - 根据当前登录用户的is_tmall判断
      return Number(this.user.is_tmall) === 1
    },
    // 代理商变更事件
    onAgentChange (agentId) {
      // 清空天猫服务区选择
      this.current.tmall_area_id = ''
      this.current.tmall_school_name = ''
      this.current.tmall_campus_name = ''
      this.current.tmall_logo = ''
      this.current.tmall_opening = 1
      this.selectedTmallArea = null
      this.tmallAreas = []
      this.tmallAreaSearchKeyword = ''
      this.tmallLogoPreview = ''
      this.hasExistingCampus = false
    },
    normalizeCampusArea (campus) {
      if (!campus) return null
      return {
        id: campus.id,
        area_id: campus.area_id || campus.id,
        area_name: campus.area_name || campus.campus_area_name || '',
        campus_area_name: campus.area_name || campus.campus_area_name || '',
        school_name: campus.school_name || '',
        campus_name: campus.campus_name || '',
        logo: campus.logo || '',
        opening: campus.opening
      }
    },
    hydrateCampusForm (campus) {
      const normalizedCampus = this.normalizeCampusArea(campus)
      if (!normalizedCampus) return
      this.selectedTmallArea = normalizedCampus
      this.tmallAreas = [normalizedCampus]
      this.tmallAreaSearchKeyword = normalizedCampus.campus_area_name || normalizedCampus.area_name || ''
      this.$set(this.current, 'tmall_area_id', normalizedCampus.id)
      this.$set(this.current, 'tmall_school_name', normalizedCampus.school_name)
      this.$set(this.current, 'tmall_campus_name', normalizedCampus.campus_name || this.current.name)
      this.$set(this.current, 'tmall_logo', normalizedCampus.logo)
      this.$set(this.current, 'tmall_opening', normalizedCampus.opening != null ? normalizedCampus.opening : 1)
    },
    // 搜索天猫服务区
    searchTmallAreas () {
      const query = this.tmallAreaSearchKeyword.trim()
      /* if (!query || query.length < 2) {
        this.$Message.warning('请输入至少2个字符进行搜索')
        return
      } */
      this.tmallAreaLoading = true

      // 构建请求参数
      const params = {
        campus_area_name: query
      }

      // 超级管理员需要传递选择的agent_id，合作伙伴账户不需要（后端会使用当前登录用户的agent_id）
      if (!this.user.tp && this.current.agent_id) {
        params.agent_id = this.current.agent_id
      }

      this.getTmallCampusAreas(params).then(res => {
        this.tmallAreaLoading = false
        if (res && res.status && res.data && res.data.result) {
          const result = res.data.result
          if (result.success && result.data && result.data.isv_campus_area_get_response) {
            this.tmallAreas = result.data.isv_campus_area_get_response
            if (this.tmallAreas.length === 0) {
              this.$Message.warning('未找到匹配的服务区')
            }
          } else {
            this.tmallAreas = []
            this.$Message.warning('未找到匹配的服务区')
          }
        } else {
          this.tmallAreas = []
          this.$Message.error('获取服务区失败')
        }
      }).catch(err => {
        console.error('获取天猫服务区失败:', err)
        this.tmallAreaLoading = false
        this.tmallAreas = []
        this.$Message.error('获取服务区失败')
      })
    },
    // 天猫服务区选择变更
    onTmallAreaChange (areaId) {
      this.selectedTmallArea = this.tmallAreas.find(a => a.id === areaId)
      this.$set(this.current, 'tmall_opening', 1)
      if (this.selectedTmallArea && !this.current.tmall_campus_name) {
        this.$set(this.current, 'tmall_campus_name', this.current.name)
      }
    },
    previewTmallLogo (file) {
      if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
        this.$Message.error('仅支持图片文件')
        return false
      }
      this.tmallLogoPreview = URL.createObjectURL(file)
      return true
    },
    uploadTmallLogoSuccess (response) {
      const logo = response && (response.path || response.data || response.url)
      if (logo) {
        this.$set(this.current, 'tmall_logo', logo)
        this.tmallLogoPreview = this.getImageUrl(logo)
      } else {
        this.$Message.warning('校区logo上传失败')
      }
    },
    uploadTmallLogoError () {
      this.$Message.warning('校区logo上传失败')
    },
    uploadTmallLogoSize (file) {
      this.$Message.warning({
        content: `图片过大(${file.name}),请上传1M以内图片`,
        duration: 5
      })
    },
    getImageUrl (url) {
      if (!url) return ''
      if (/^https?:\/\//.test(url)) return url
      return config.imgSrc + url
    },
    sizeChange (l) {
      this.page.l = l
      this.getData()
    },
    pageChange (p) {
      this.page.p = p - 1
      this.getData()
    },
    getData (filter) {
      if (filter) {
        this.page.p = 0
      }
      this.tableLoading = true
      this.getSite(this.page).then(res => {
        this.total = res.total
        this.data = res.data
        this.tableLoading = false
      })
    },
    ...mapActions(['getSite', 'getAgentList', 'saveSite', 'DelSite', 'getTmallCampusAreas'])
  },
  mounted () {
    this.getData()
    this.baseUrl =
      process.env.NODE_ENV === 'development'
        ? config.baseUrl.dev
        : config.baseUrl.pro
  },
  computed: mapGetters({
    user: 'agent',
    access: 'access'
  }),
  watch: {
    'page.is_del' (n, o) {
      this.getData()
    }
  }
}
</script>

<style lang="less">
  @import './index.less';
</style>
